import { render, staticRenderFns } from "./AddEditAutomation2.vue?vue&type=template&id=3bc20e2e"
import script from "./AddEditAutomation2.vue?vue&type=script&lang=js"
export * from "./AddEditAutomation2.vue?vue&type=script&lang=js"
import style0 from "./AddEditAutomation2.vue?vue&type=style&index=0&id=3bc20e2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports